export default __webpack_public_path__ + "maksim@2x.418e4ccc.png";